// extracted by mini-css-extract-plugin
export var contentBody = "_c0-9";
export var headerImage = "_c0-2";
export var imageButton = "_c0-7";
export var imageButtonIcon = "_c0-8";
export var imageHeader = "_c0-4";
export var imageHeaderText = "_c0-5";
export var imageOverlay = "_c0-3";
export var imageTitle = "_c0-6";
export var imageWrapper = "_c0-1";
export var taskList = "_c0-a";
export var widget = "_c0-0";